import { render } from "./AssistantPanel.vue?vue&type=template&id=36799d1d&scoped=true"
import script from "./AssistantPanel.vue?vue&type=script&lang=js"
export * from "./AssistantPanel.vue?vue&type=script&lang=js"

import "./AssistantPanel.vue?vue&type=style&index=0&id=36799d1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36799d1d"]])

export default __exports__